import numeral from 'numeral';

export const formatValue = (value: number): string => {
  if (Number.isInteger(value) && Math.abs(value) < 1e12) {
    return numeral(value).format('0,0');
  }
  return numeral(value).format('0,0.00');
};
